module.exports = __webpack_public_path__ + "static/media/dartboardExample.9fdffbce.png";